/**
 * IdleWarningModal
 *
 * Shown 5 minutes before the 4-hour inactivity auto-logout fires (see
 * hooks/useInactivityLogout.js). Disappears automatically as soon as the
 * user moves the mouse / types / scrolls / clicks (activity resets the
 * guard, which hides the modal via onResetWarn). If they do nothing, they
 * are signed out for their safety when the 4-hour mark is reached.
 */
export default function IdleWarningModal({ visible, onStaySignedIn }) {
  if (!visible) return null;

  return (
    <div
      className="idle-modal__overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Session expiring"
    >
      <div className="idle-modal__box">
        <div className="idle-modal__icon">⏱️</div>
        <h2 className="idle-modal__title">Still there?</h2>
        <p className="idle-modal__body">
          You've been inactive for a while. You'll be signed out in{' '}
          <strong>5 minutes</strong> to keep your account secure.
        </p>
        <button className="idle-modal__btn" onClick={onStaySignedIn} type="button">
          Keep me signed in
        </button>
      </div>
    </div>
  );
}
